// utils/paypal-script-singleton.ts

import { loadScript } from '@paypal/paypal-js'

let cachedPaypalPromise: Promise<any> | null = null

const SCRIPT_OPTIONS = {
  'client-id': process.env.NEXT_PUBLIC_PAYPAL_CLIENT_ID,
  'currency': 'EUR',
  'intent': 'capture',
  'components': 'messages',
}

/**
 * Ensures the PayPal script is only loaded into the DOM once,
 * even if called multiple times from different components.
 * @returns A promise that resolves with the PayPal object.
 */
export const loadPayPalScriptSingleton = (): Promise<any> => {
  if (!cachedPaypalPromise) {
    // If the promise doesn't exist, create it by calling loadScript
    cachedPaypalPromise = loadScript(SCRIPT_OPTIONS).catch((error) => {
      // Handle script loading failure but keep the promise state reset if needed
      console.error('PayPal script failed to load:', error)
      // Optionally reset the cache so a retry can happen
      cachedPaypalPromise = null
      throw error
    })
  }
  // Always return the single, cached promise
  return cachedPaypalPromise
}
